export default "__VITE_ASSET__BqttpkeO__"